import React from 'react';
import { useParams } from 'react-router-dom';
import { courses } from "../components/assets/data/dummydata";

export const CourseDetail = () => {
  const { id } = useParams();

  const course = courses.find((item) => item.id.toString() === id);

  if (!course) {
    return <div className='text-center text-red-500'>Course not found</div>;
  }

  return (
    <section className='container mx-auto py-10'>
      <h1 className='text-4xl font-bold text-blue-700 mb-4'>{course.title}</h1>
      <img src={course.cover} alt={course.title} className='w-full h-64 object-cover rounded-lg shadow-md mb-6' />

      <div className='bg-gray-100 p-6 rounded-lg shadow-md mb-6'>
        <h3 className='text-2xl font-semibold mb-2'>Course Description</h3>
        <p className='text-gray-700'>{course.description}</p>
      </div>

      <div className='bg-gray-100 p-6 rounded-lg shadow-md mb-6'>
        <h3 className='text-2xl font-semibold mb-2'>Units</h3>
        <ul className='list-disc pl-5 text-gray-700'>
          {course.units.map((unit, index) => (
            <li key={index} className='mb-1'>{unit}</li>
          ))}
        </ul>
      </div>

      <div className='bg-gray-100 p-6 rounded-lg shadow-md mb-6'>
        <h3 className='text-2xl font-semibold mb-2'>Video Preview</h3>
        <video controls className='w-full rounded-lg shadow'>
          <source src={course.previewUrl} type='video/mp4' />
          Your browser does not support the video tag.
        </video>
      </div>
    </section>
  );
};
